var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgYellowLine = function SvgYellowLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 823,
    height: 429,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808.354 8.11c-82.755 153.136-312.258 447.195-568.228 398.332C-79.836 345.363-30.793 50.845 233.4 133.424",
    stroke: "#FFD912",
    strokeWidth: 33
  })));
};
export default SvgYellowLine;